import { helper } from '@ember/component/helper';
import { HostDatabaseLabels } from 'donor-elf-web/services/fund-mappings-service';

export default helper(function ([databaseId]: string[]) {
  return HostDatabaseLabels[databaseId] || databaseId;
});
